module.exports = __webpack_public_path__ + "6bc2c17/img/twitt.dd69d195.svg";